import { NToastNotifyToastr } from "./NToastNotifyToastr";

export let toastr = new NToastNotifyToastr()


// WEBPACK FOOTER //
// ./Js/src/toastr/index.ts